import { useState } from 'react';
import { ShoppingCart, TrendingUp } from 'lucide-react';
import { AlertBanner, PageHeader, Tabs } from '@/components/ui';
import type { TabItem } from '@/components/ui';
import { FacturesTab } from '@/modules/achats/AchatsPage';
import { FacturesVenteTab } from '@/modules/factures/FacturesVenteTab';

/**
 * Module COMPTABLE « Factures » — registre des factures réelles (avec pièce justificative),
 * distinct du module Dépenses (analytique de gestion). Base des futures sorties comptables
 * (G50 à l'encaissement, état des fournisseurs / clients). Aucune interaction automatique
 * avec les Dépenses ni les Situations de travaux.
 *
 * Deux onglets, strictement séparés (jamais de mélange ventes / achats) :
 * - Achat (fournisseurs & sous-traitants) → TVA déductible ;
 * - Production (clients) → TVA collectée.
 */
const TABS: TabItem[] = [
  { key: 'achat', label: 'Achat — fournisseurs & sous-traitants', icon: <ShoppingCart className="size-4" /> },
  { key: 'production', label: 'Production — clients', icon: <TrendingUp className="size-4" /> },
];

export function FacturesPage() {
  const [tab, setTab] = useState('achat');
  return (
    <>
      <PageHeader
        title="Factures"
        subtitle="Registre comptable des factures réelles — base du G50 et des états fournisseurs / clients"
        breadcrumbs={[{ label: 'Advanced Works ERP' }, { label: 'Factures' }]}
      />
      <Tabs tabs={TABS} value={tab} onChange={setTab} className="mb-4" />
      {tab === 'achat' ? (
        <AlertBanner variant="info" className="mb-4">
          <strong>Achat</strong> (TVA déductible) : factures fournisseurs et sous-traitants — réelles, avec
          pièce justificative et paiements (G50 à l'encaissement). Indépendant du module
          <strong> Dépenses</strong> (analytique) — aucun double comptage.
        </AlertBanner>
      ) : (
        <AlertBanner variant="info" className="mb-4">
          <strong>Production</strong> (TVA collectée) : factures clients — réelles, avec encaissements en
          tranches (G50 à l'encaissement). La <strong>retenue de garantie</strong> est suivie par les
          encaissements réels. Indépendant des <strong>Situations de travaux</strong> (analytique) — aucune
          dérivation automatique.
        </AlertBanner>
      )}
      {tab === 'achat' && <FacturesTab />}
      {tab === 'production' && <FacturesVenteTab />}
    </>
  );
}
